import { css } from '@emotion/react';
import { FC } from 'react';
import { Flex, Button } from '@chakra-ui/react';
import { colors, fontStyles, spacing } from '../../../styles';

interface Props {
  selected: string;
  onSelect: (metric: string) => void;
}

const METRICS = [
  { value: 'totalRevenue', label: 'Revenue' },
  { value: 'grossProfit', label: 'Gross Profit' },
  { value: 'operatingIncome', label: 'Operating Income' },
  { value: 'operatingCashflow', label: 'Operating CF' },
  { value: 'ebitda', label: 'EBITDA' },
  { value: 'netIncome', label: 'Net Income' },
  { value: 'freeCashFlow', label: 'FCF' },
];

const MetricChips: FC<Props> = ({ selected, onSelect }) => {
  return (
    <Flex css={styles.container} wrap="wrap" gap={2}>
      {METRICS.map((metric) => (
        <Button
          key={metric.value}
          size="sm"
          variant={selected === metric.value ? 'solid' : 'outline'}
          onClick={() => onSelect(metric.value)}
          css={[styles.chip, selected === metric.value && styles.selectedChip]}
        >
          {metric.label}
        </Button>
      ))}
    </Flex>
  );
};

const styles = {
  container: css`
    margin-bottom: ${spacing.deci};
  `,
  chip: css`
    ${fontStyles.flea};
    flex-shrink: 0;
    border-radius: 16px;
    padding: ${spacing.milli} ${spacing.centi};
    border: 1px solid ${colors.cloud};
    background-color: transparent;
    color: ${colors.tungsten};
    html[data-theme='dark'] & {
      border-color: ${colors.tungsten};
      color: ${colors.cloud};
    }
    &:hover {
      background-color: ${colors.fog};
      html[data-theme='dark'] & {
        background-color: ${colors.tungsten};
      }
    }
  `,
  selectedChip: css`
    background-color: ${colors.petrolBlue};
    border-color: ${colors.petrolBlue};
    color: ${colors.sugar};
    html[data-theme='dark'] & {
      background-color: ${colors.skyBlue};
      border-color: ${colors.skyBlue};
      color: ${colors.liquorice};
    }
    &:hover {
      background-color: ${colors.petrolBlue};
      html[data-theme='dark'] & {
        background-color: ${colors.skyBlue};
      }
    }
  `,
};

export default MetricChips;
